import { render } from "./CustomFieldsHeader.vue?vue&type=template&id=3feb9a7f&scoped=true"
import script from "./CustomFieldsHeader.vue?vue&type=script&lang=js"
export * from "./CustomFieldsHeader.vue?vue&type=script&lang=js"

import "./CustomFieldsHeader.vue?vue&type=style&index=0&id=3feb9a7f&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feb9a7f"]])

export default __exports__